import LoginLayout from "../../layouts/LoginLayout";
import RegisterCard from "../../components/auth/RegisterCard";

export default function Register() {
  return <LoginLayout>
    <RegisterCard />
  </LoginLayout>;
}
